import { PUMP_FUN_URL } from "@/components/ContractAddress";

export default function Navbar() {
  const links = [
    { label: "ABOUT", id: "about" },
    { label: "TOKENOMICS", id: "tokenomics" },
    { label: "ROADMAP", id: "roadmap" },
    { label: "COMMUNITY", id: "community" },
  ];

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      data-testid="main-navbar"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#05050A]/70 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <a
          data-testid="navbar-logo"
          href="#hero"
          className="flex items-center gap-2 font-heading font-black text-white"
        >
          <span className="inline-block w-2.5 h-2.5 bg-[#00F0FF] shadow-[0_0_15px_#00F0FF] animate-pulse" />
          <span className="tracking-tight">
            $LA28<span className="text-[#FFD700] ml-1">·</span>
            <span className="text-white/80 ml-1 hidden sm:inline">ARMY</span>
          </span>
        </a>
        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="font-mono text-xs tracking-[0.22em] text-white/70 hover:text-[#00F0FF] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </div>
        <button
          data-testid="nav-cta-buy"
          onClick={() => window.open(PUMP_FUN_URL, "_blank")}
          className="btn-neon !py-2.5 !px-4 text-[10px]"
        >
          PUMP.FUN
        </button>
      </div>
    </nav>
  );
}
